module.exports = __webpack_public_path__ + "static/media/swimmer.0fbf9300.svg";